//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
import { PojoMap } from 'pojo-maps';

import Cuid from '@models/Cuid';
import ReelId from '@models/ReelId';

export enum FanreelsApiModerationStatuses {
    REJECTED = 'rejected',
}

export interface IMinimalFanreel {
  id: ReelId;
  name: string;
}

export interface IItemInReelResult {
  isApproved: boolean;
}

export interface IApprovedReelsResponse {
  data: PojoMap<Cuid, ReelId[]>;
}
